export default function initVideo(): void {
    // fix autoplay when not really playing
    document.body.querySelectorAll<HTMLVideoElement>("video[autoplay]").forEach(video => {
        setTimeout(() => {
            if (!video.currentTime) {
                video.play();
            }
        }, 2000);
    });

    // handle redirection when video is ended
    document.body.querySelectorAll<HTMLVideoElement>("#video-container video[data-goto]").forEach(video => {
        video.addEventListener("ended", () => {
            document.location.assign(video.dataset.goto!);
        });
    });

    // toggle popup when clicking on specific links
    document.body.addEventListener("click", e => {
        const el = (e.target as HTMLElement).closest<HTMLElement>("[data-popup]");
        if (!el) {
            return;
        }

        const target = document.body.querySelector(el.dataset.popup!);
        if (target) {
            target.classList.toggle("open");
            target.dispatchEvent(new Event("show.bs.modal"));
        }
    });

    // enable sharing link when possible
    if (navigator.share) {
        document.body.querySelectorAll<HTMLElement>("[data-share]").forEach(el => {
            el.classList.remove("d-none");
            el.addEventListener("click", () => {
                navigator
                    .share(JSON.parse(el.dataset.share!))
                    .catch(error => console.error("Error sharing", error));
            });
        });
    }
}
